
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Solutions() {
  const industries = [
    {
      icon: 'ri-bank-line',
      title: 'Finance',
      description: 'Risk assessment, fraud detection, algorithmic trading, and regulatory compliance. Transform financial data into competitive advantages.',
      features: ['Risk Analytics', 'Fraud Detection', 'Compliance Reporting', 'Market Analysis']
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Healthcare',
      description: 'Patient outcomes prediction, operational efficiency, clinical research, and population health management.',
      features: ['Patient Analytics', 'Clinical Research', 'Operational Insights', 'Population Health']
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Manufacturing',
      description: 'Predictive maintenance, quality control, supply chain optimization, and production planning.',
      features: ['Predictive Maintenance', 'Quality Control', 'Supply Chain', 'Production Planning']
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'Retail & E-commerce',
      description: 'Customer behavior analysis, inventory optimization, personalized recommendations, and demand forecasting.',
      features: ['Customer Analytics', 'Inventory Management', 'Personalization', 'Demand Forecasting']
    },
    {
      icon: 'ri-government-line',
      title: 'Government & Smart Cities',
      description: 'Public service optimization, urban planning, citizen engagement, and resource allocation.',
      features: ['Public Services', 'Urban Planning', 'Citizen Engagement', 'Resource Management']
    }
  ];

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            Solutions for Every Industry
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Discover how Prismatics AI transforms data challenges into competitive advantages across diverse industries. Unlock the power of intelligent automation and predictive analytics tailored to your sector's unique needs.
          </p>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {industries.map((industry, index) => (
              <div key={index} className="p-8 bg-gray-900 rounded-2xl border border-gray-800 hover:border-blue-500 transition-all duration-300">
                <div className="flex items-start space-x-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex-shrink-0">
                    <i className={`${industry.icon} text-2xl text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">{industry.title}</h3>
                    <p className="text-gray-300 mb-6 leading-relaxed">{industry.description}</p>
                    <div className="grid grid-cols-2 gap-2">
                      {industry.features.map((feature, featureIndex) => (
                        <div key={featureIndex} className="flex items-center space-x-2">
                          <i className="ri-check-line text-green-400 text-sm"></i>
                          <span className="text-sm text-gray-400">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-6">Real-World Impact</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              See how organizations across industries are leveraging Prismatics AI to drive measurable results.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="text-4xl font-bold text-blue-400 mb-2">85%</div>
              <div className="text-gray-300">Reduction in analysis time</div>
            </div>
            <div className="text-center p-6">
              <div className="text-4xl font-bold text-purple-400 mb-2">3x</div>
              <div className="text-gray-300">Faster decision making</div>
            </div>
            <div className="text-center p-6">
              <div className="text-4xl font-bold text-green-400 mb-2">40%</div>
              <div className="text-gray-300">Increase in operational efficiency</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-900 to-purple-900">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ready to Transform Your Industry?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Join industry leaders who are already leveraging AI to stay ahead of the competition.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/schedule-demo" className="inline-block">
              <button className="whitespace-nowrap cursor-pointer font-medium transition-all duration-200 flex items-center justify-center bg-gray-800 hover:bg-gray-700 text-white border border-gray-700 px-8 py-4 text-lg rounded-xl">
                <i className="ri-calendar-line mr-2"></i>
                Schedule Demo
              </button>
            </a>
            <a href="/contact" className="inline-block">
              <button className="whitespace-nowrap cursor-pointer font-medium transition-all duration-200 flex items-center justify-center border border-blue-500 text-blue-400 hover:bg-blue-500 hover:text-white px-8 py-4 text-lg rounded-xl">
                <i className="ri-chat-3-line mr-2"></i>
                Contact Sales
              </button>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
